import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import MediaQuery from 'react-responsive'

let confirmationPage = window.location.pathname.substring(
  0,
  window.location.pathname.indexOf('/', 2)
)

const donationPage = () => {
  window.location.href = '/donation'
}
/* eslint-disable */

const PdfPrint = () => {
    html2canvas(document.body).then(function(canvas) {
      var imgData = canvas.toDataURL('image/png');
      var imgWidth = 210; 
      var pageHeight = 295;  
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      var pdf = new jsPDF('p', 'mm', 'a4',true);
      var position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '','FAST');
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, '','FAST');
        heightLeft -= pageHeight;
      }
      pdf.save( 'print-order.pdf');
    });


}


/* eslint-enable */
const PrintButton = props => (
  <div className='cart-done row px-2 pt-2 d-print-none'>
    {confirmationPage === '/confirmation' ? (
      <div className='col-12 row mx-0'>
        {props.campaignHasDonation ? (
          <div className='col-12 mb-2 justify-content-center align-self-center'>
            <Button
              className='btn btn-sm btn-featured btn-icon'
              text='Fazer uma doação'
              iconName='icon_donation'
              onClick={() => donationPage()}
            />
          </div>
        ) : (
          ''
        )}
        <div className='col-12 justify-content-center align-self-center'>
          <MediaQuery minDeviceWidth={476}>
            <Button
              className='btn btn-sm btn-featured btn-cart btn-icon'
              text='Imprimir Pedido'
              iconName='icon_press'
              onClick={() => window.print()}
            />
          </MediaQuery>
          <MediaQuery maxDeviceWidth={475}>
            <Button
              className='btn btn-sm btn-featured btn-cart btn-icon'
              text='Imprimir Pedido'
              iconName='icon_press'
              onClick={() => window.print()}
            />
          </MediaQuery>
        </div>
      </div>
    ) : (
      <div className='col-12 justify-content-center align-self-center'>
        <MediaQuery minDeviceWidth={476}>
          <Button
            className='btn btn-sm btn-featured btn-cart btn-icon'
            text='Imprimir Pedido'
            iconName='icon_press'
            onClick={() => window.print()}
          />
        </MediaQuery>
        <MediaQuery maxDeviceWidth={475}>
          <Button
            className='btn btn-sm btn-featured btn-cart btn-icon'
            text='Imprimir Pedido'
            iconName='icon_press'
            onClick={() => window.print()}
          />
        </MediaQuery>

      </div>
    )}
  </div>
)

PrintButton.propTypes = {
  campaignHasDonation: PropTypes.bool
}

export default PrintButton



// WEBPACK FOOTER //
// ./src/features/About/PrintButton.js